import {observer} from "mobx-react-lite";
import {useEffect} from "react";
import clubStore from "../../../storage/ClubStore";
import Competition from "./Competition";

const NewCompetition = () => {
    useEffect(() => {
        clubStore.tournament.resetCompetition()
    }, [])
    return (
        <Competition/>
    )
}
export default observer(NewCompetition)